// extracted by mini-css-extract-plugin
export default {"additionalDataWrapper":"ForetagSearchForm_additionalDataWrapper__j11Hp"};